var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { styles } from './style.js';
const _fetchMap = new Map();
const ERROR_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"></svg>';
/**
 * A minimal in-memory map to de-duplicate Fetch API media requests.
 *
 * @param uri - Resource URL
 * @param options - Optional parser for the response
 * @returns Promise of parsed response
 */
function cacheFetch(uri, options = {}) {
    const parser = options.responseParser ?? ((res) => res.text());
    if (!_fetchMap.has(uri)) {
        _fetchMap.set(uri, fetch(uri).then(parser));
    }
    return _fetchMap.get(uri);
}
export class WIcon extends LitElement {
    constructor() {
        super(...arguments);
        /** Locale used in CDN URL */
        this.locale = document.documentElement.lang || 'en';
        /** Parsed SVG element (not reflected as attribute) */
        this.svg = null;
    }
    static { this.styles = [styles]; }
    /**
     * Fetch an icon SVG from the CDN, with caching
     * @param iconName - Name of the icon file
     * @returns SVGElement or null on failure
     */
    async fetchIcon(iconName) {
        const uri = `https://assets.finn.no/pkg/eikons/v1/${this.locale}/${iconName}.svg`;
        try {
            const svgText = await cacheFetch(uri);
            const doc = new DOMParser().parseFromString(svgText, 'text/html');
            return doc.body.querySelector('svg');
        }
        catch {
            return null;
        }
    }
    firstUpdated() {
        this.loadIcon();
    }
    updated(changedProps) {
        if (changedProps.has('name') || changedProps.has('locale')) {
            this.loadIcon();
        }
    }
    async loadIcon() {
        if (!this.name) {
            this.svg = null;
            return;
        }
        let iconEl = await this.fetchIcon(this.name);
        if (!iconEl) {
            const doc = new DOMParser().parseFromString(ERROR_SVG, 'text/html');
            iconEl = doc.body.firstElementChild;
        }
        this.svg = iconEl;
    }
    render() {
        const size = this.size || 'medium';
        const name = this.name || '';
        const classes = {
            'w-icon': true,
            'w-icon--s': size === 'small',
            'w-icon--m': size === 'medium',
            'w-icon--l': size === 'large',
        };
        const customStyle = typeof size === 'string' && size.endsWith('px') ? `--w-icon-size: ${size};` : '';
        return html `<div class="${classMap(classes)}" style="${customStyle}" part="w-${name.toLowerCase()}">${this.svg}</div>`;
    }
}
__decorate([
    property({ type: String, reflect: true })
], WIcon.prototype, "name", void 0);
__decorate([
    property({ type: String, reflect: true })
], WIcon.prototype, "size", void 0);
__decorate([
    property({ type: String, reflect: true, useDefault: true })
], WIcon.prototype, "locale", void 0);
__decorate([
    state()
], WIcon.prototype, "svg", void 0);
if (!customElements.get('w-icon')) {
    customElements.define('w-icon', WIcon);
}
//# sourceMappingURL=icon.js.map